module.exports = __webpack_public_path__ + "img/icon_addservices_index.4afdf7b5.svg";